import { useEffect, useState } from "react";
import { app, authentication } from "@microsoft/teams-js";
import { Box, Typography, CircularProgress } from "@mui/material";

const AuthCallback = () => {
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    app.initialize().then(() => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const error = params.get("error");

      console.log("Done Auth, Now @ AuthCallback.js");

      setTimeout(() => {
        if (code) {
          authentication.notifySuccess(code);
          setStatus("success");
        } else {
          authentication.notifyFailure(error || "No code returned");
          setStatus("error");
        }
      }, 1000);
    });
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {status === "pending" && "Completing authentication…"}
        {status === "success" && "Authentication successful!"}
        {status === "error" && "Authentication failed."}
      </Typography>
      {status !== "pending" && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          You may now close this window.
        </Typography>
      )}
    </Box>
  );
};

export default AuthCallback;
